<template>
  <div id="app">
    <HelloWorld />
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import HelloWorld from './components/HelloWorld.vue';

export default {
  name: 'app',
  components: {
    HelloWorld,
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Lato');
@import url('https://fonts.googleapis.com/css?family=Raleway:300,400,600');
@import url('https://fonts.googleapis.com/css?family=Roboto:400,600');

:root {
  --color-green-1: #00a882;
  --color-orange-1: #ff7300;
  --color-grey-1: #f1f1f1;
  --color-grey-2: #4f4f4f;
  --color-grey-3: #565656;
  --color-grey-4: #777777;
}

@-webkit-keyframes bounce {
 0%, 20%, 50%, 80%, 100% {-webkit-transform: translateY(0);} 
 40% {-webkit-transform: translateY(-15px);}
 60% {-webkit-transform: translateY(-6px);}
}
 
@-moz-keyframes bounce {
 0%, 20%, 50%, 80%, 100% {-moz-transform: translateY(0);}
 40% {-moz-transform: translateY(-15px);}
 60% {-moz-transform: translateY(-6px);}
}
 
@-o-keyframes bounce {
 0%, 20%, 50%, 80%, 100% {-o-transform: translateY(0);}
 40% {-o-transform: translateY(-15px);}
 60% {-o-transform: translateY(-6px);}
}
@keyframes bounce {
 0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
 40% {transform: translateY(-15px);}
 60% {transform: translateY(-6px);}
}

#app {
  background-color: white;
  font-family: "Raleway", sans-serif;
  color: var(--color-grey-2);
  font-size: 18px;
}

.modal-open {
  height: calc(100vh);
  overflow: hidden;
}

.flex-row {
  display: flex;
  width: 100%;
}

.row {
  margin-left: 0;
  margin-right: 0;
}

h1 {
  font-size: 36px;
  text-align: center;
}

.orange-link {
  color: var(--color-orange-1) !important;
  cursor: pointer;
}

.btn:focus, .btn.focus {
  box-shadow: none;
}

section {
  padding-top: 80px;
  padding-bottom: 80px;
}

.sub-heading {
  margin-bottom: 85px;
  font-weight: 300;
  text-align: center;
  padding-left: 60px;
  padding-right: 60px;
}

a.btn {
  cursor: pointer;
}

a.btn.btn-primary, button.btn.btn-primary {
  background-color: var(--color-green-1);
  border: 2px solid var(--color-green-1);
  color: white;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 15px;
  padding-right: 15px;
  letter-spacing: 1px;
  cursor: pointer;
}

a.btn.btn-primary:hover, button.btn.btn-primary:hover {
  background-color: white;
  color: var(--color-green-1);
}

a.btn.btn-grey, button.btn.btn-grey {
  background-color: var(--color-grey-1);
  border: 2px solid var(--color-grey-1);
  color: var(--color-grey-2);
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 15px;
  padding-right: 15px;
  letter-spacing: 1px;
}

.btn {
  border-radius: 25px;
}

a.btn.btn-grey:hover, button.btn.btn-grey:hover {
  border: 2px solid var(--color-grey-2);
}

a.btn.btn-inverse, button.btn.btn-inverse {
  border-radius: 8px;
  border: 2px solid white;
  background: transparent;
  color: white;
  letter-spacing: 1px;
  padding-top: 10px;
  padding-bottom: 10px;
}

a.btn.btn-inverse:hover, button.btn.btn-inverse:hover {
  background: white;
  color: var(--color-green-1);
}

a.btn.btn-orange, button.btn.btn-orange {
  background-color: var(--color-orange-1);
  border: 2px solid var(--color-orange-1);
  color: white;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 15px;
  padding-right: 15px;
  letter-spacing: 1px;
  font-size: 18px;
  width: 100%;
  text-transform: uppercase;
  cursor: pointer;
}

a.btn.btn-orange:hover, button.btn.btn-orange:hover {
  background-color: white;
  color: var(--color-orange-1);
}

.uppercase {
  text-transform: uppercase;
}

.form-group input, .form-group textarea {
  padding: 17px;
  font-size: 14px;
}

@media screen and (max-width: 768px) {
  section {
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 40px;
  }

  .sub-heading {
    padding-left: 20px;
    padding-right: 20px;
  }

  .responsive-row {
    display: block;
  }
}
</style>
